import { ChronocodeVO } from '../chronocode.vo';
import { FreedataValueVO } from '../freedatavalue.vo';
import { IncExcMainObj } from './incex.main.obj';
import { ViewData } from '../../../model/view.data';
import { INC_EXC_KIND } from '../../../model/enums';

/** encapsulation d'un ChronocodeVO ou d'un freedataValueVO pour affectation dans une clé d'inclusion / exclusion */
export class IncExcContentObj {
  // portée de l'objet, un FD, FDLVL, CHRON, CHRONLVL
  public chrono: ChronocodeVO = null;
  public freedataValue: FreedataValueVO = null;

  public parent: IncExcMainObj = null; // lien vers le parent pour gestion des rendus

  public source: ChronocodeVO | FreedataValueVO;
  public kind: INC_EXC_KIND = null; // selon le type

  /**
   * constructeur composite
   * @param chrono 1
   * @param freedataValue 2
   */
  public constructor(parent: IncExcMainObj, chrono: ChronocodeVO = null, freedataValue: FreedataValueVO = null) {
    this.parent = parent;
    if (chrono) {
      this.chrono = chrono;
      this.source = chrono;
      this.kind = INC_EXC_KIND.CHRO;
    } else if (freedataValue) {
      this.freedataValue = freedataValue;
      this.source = freedataValue;
      this.kind = INC_EXC_KIND.FDV;
    }
  }

  /** accesseur sur le code */
  public get code(): string {
    return this.source.code;
  }

  /** accesseur sur le parent (au sens FD-hiérarchique) pour rendu dans le tree */
  public get parentCode(): string {
    return this.source.parentCode;
  }

  /** accesseur sur le libellé traduit */
  public get label(): string {
    return this.source.trsLabel;
  }

  /** accesseur sur le level de cette valeur */
  public get level(): number {
    return this.source.level;
  }

  /** accesseur composite */
  public get fullLabel(): string {
    return this.label + ' (' + this.code + ')';
  }

  /** retour le libellé du FD ou chrono porteur */
  public get parentFullLabel(): string {
    return this.parent.fullLabel;
  }

  /* #############################################################
               Accesseur pour construction des incExcKeys
     ############################################################# */

  /** retourne la partie "main" du code (sans le level) */
  public get mainCodePart(): string {
    return this.parent.incexcMasterCode;
  }

  /**
   * retourne la partie FD ou CHRONO de cet élément, avec son level
   * on prend le incexcMasterCode, donc CHRONO pour les chronos
   */
  public get codePart(): string {
    return this.parent.incexcMasterCode + ViewData.CONTEXT_SEPARATOR + this.level;
  }

  /** retourne la partie value de cet élément */
  public get valuePart(): string {
    return this.code;
  }
}
